import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {Logger, LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {WalkOfShameGameAssets} from "./WalkOfShameGameAssets";
import {WalkOfShameSound} from "./sound/WalkOfShameSound";
import {WalkOfShameBackground} from "./view/WalkOfShameBackground";
import {WalkOfShameWinPresentation} from "./gameflow/WalkOfShameWinPresentation";
import {WalkOfShameNormalBetPresentation} from "./gameflow/WalkOfShameNormalBetPresentation";
import {WalkOfShameNormalResultPresentation} from "./gameflow/WalkOfShameNormalResultPresentation";
import {WalkOfShameNormalIdlePresentation} from "./gameflow/WalkOfShameNormalIdlePresentation";
import {WalkOfShameZeroBetIdlePresentation} from "./gameflow/WalkOfShameZeroBetIdlePresentation";
import {WalkOfShameModel} from "./server/WalkOfShameModel";
import {WalkOfShameLayers} from "./view/WalkOfShameLayers";
import {WalkOfShameReelController} from "./reels/WalkOfShameReelController";
import {WalkOfShameGameConfig} from "./WalkOfShameGameConfig";
import {ReelStopPresentationManager} from "./reelstoppresentation/ReelStopPresentationManager";
import {ReelStopSoundController} from "./reelstoppresentation/presentations/ReelStopSoundController";
import {WinPresentationManager} from "./winpresentation/WinPresentationManager";
import {Scatter2LandingController} from "./reelstoppresentation/presentations/Scatter2LandingController";
import {ScatterLandingController} from "./reelstoppresentation/presentations/ScatterLandingController";
import {InitialWinCountUp} from "./winpresentation/presentations/initial/InitialWinCountUp";
import {BigWinCountUp} from "./winpresentation/presentations/bigwin/BigWinCountUp";
import {BigWinController} from "./winpresentation/presentations/bigwin/BigWinController";
import {InitialWinController} from "./winpresentation/presentations/initial/InitialWinController";
import {IndividualWinController} from "./winpresentation/individual/IndividualWinController";
import {FreespinIntro} from "./screen/FreespinIntro";
import {WalkOfShameFreespinIdlePresentation} from "./gameflow/WalkOfShameFreespinIdlePresentation";
import {FreespinWinController} from "./winpresentation/presentations/FreespinWinController";
import {FreespinOutro} from "./screen/FreespinOutro";
import {FreespinEndController} from "./winpresentation/presentations/FreespinEndController";
import {WinCapScreen} from "./screen/WinCapScreen";
import {BreakBankController} from "./winpresentation/presentations/BreakBankController";
import {BelowStakeWinRestriction} from "./server/BelowStakeWinRestriction";
import {WalkOfShameGameMode} from "./server/WalkOfShameGameMode";
import {ISymbolValues} from "./server/data/IWalkOfShameData";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {WalkOfShameMultiplier} from "./view/WalkOfShameMultiplier";
import {WalkOfShameWinWays} from "./view/WalkOfShameWinWays";
import {MToWildController} from "./winpresentation/mToWild/MToWildController";
import {StickyS2Overlay} from "./component/StickyS2Overlay";
import {ReSpinEndController} from "./winpresentation/presentations/ReSpinEndController";
import {MToWildView} from "./view/MToWildView";
import {ReelSplitController} from "./winpresentation/presentations/ReelSplitController";
import {RowSplitController} from "./winpresentation/presentations/RowSplitController";
import {ReSpinStartController} from "./winpresentation/presentations/ReSpinStartController";
import {WalkOfShameSplitAnimation} from "./view/WalkOfShameSplitAnimation";
import {WalkOfShameReelBackground} from "./view/WalkOfShameReelBackground";
import {WalkOfShameLogo} from "./view/WalkOfShameLogo";
import {WalkOfShameBlackOverlay} from "./view/WalkOfShameBlackOverlay";
import {WalkOfShamePossibleWays} from "./view/WalkOfShamePossibleWays";
import {ParticlesManager} from "./component/particles/ParticlesManager";
import {WalkOfShameAnticipation} from "./view/WalkOfShameAnticipation";
import {WalkOfShameSymbolCount} from "./view/WalkOfShameSymbolCount";
import {WalkOfShameAdditionalFS} from "./view/WalkOfShameAdditionalFS";
import {WalkOfShameSymbol} from "./symbol/WalkOfShameSymbol";
import {WalkOfShameSymbolState} from "./symbol/WalkOfShameSymbolConfig";
import {TimelineLite} from "gsap";
import {ScattersNoWinController} from "./winpresentation/presentations/ScattersNoWinController";
import {WalkOfShameParsedInitData} from "./server/data/WalkOfShameParsedInitData";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class WalkOfShame extends SlotGame {
    public static isActionSpinsActive:boolean=false;
    public static model: WalkOfShameModel;
    public static gameFlowController: GameFlowController;
    public static assetLoader: AssetLoader;
    public static reels: WalkOfShameReelController[];
    public static reelStopPresentations: ReelStopPresentationManager;
    public static winPresentations: WinPresentationManager;
    public static initialCountUp: InitialWinCountUp;
    public static bigWinCountUp: BigWinCountUp;
    public static individualWin: IndividualWinController;
    public static freespinIntro: FreespinIntro;
    public static freespinOutro: FreespinOutro;
    public static winCapScreen: WinCapScreen;
    public static background: WalkOfShameBackground;
    public static multiplier: WalkOfShameMultiplier;
    public static winWays: WalkOfShameWinWays;
    public static stickyS2: StickyS2Overlay;
    public static mToWild: MToWildView;
    public static splitAnimation: WalkOfShameSplitAnimation;
    public static reelBackground: WalkOfShameReelBackground;
    public static logo: WalkOfShameLogo;
    public static blackOverlay: WalkOfShameBlackOverlay;
    public static possibleWays: WalkOfShamePossibleWays;
    public static particlesManager: ParticlesManager;
    public static anticipation: WalkOfShameAnticipation;
    public static symbolCount: WalkOfShameSymbolCount;
    public static additionalFS: WalkOfShameAdditionalFS;

    private _defaultSymbolValues: ISymbolValues = {
        "L1": {3: 5, 4: 10, 5: 20},
        "L2": {3: 5, 4: 10, 5: 20},
        "L3": {3: 4, 4: 8, 5: 15},
        "L4": {3: 3, 4: 6, 5: 15},
        "L5": {3: 3, 4: 6, 5: 15},
        "M1": {3: 15, 4: 30, 5: 80},
        "M2": {3: 10, 4: 20, 5: 60},
        "M3": {3: 9, 4: 18, 5: 40},
        "M4": {3: 8, 4: 16, 5: 25}
    };

    constructor() {
        super();
    }

    public static updateMode(mode: string, calledFromInit: boolean): void {
        WalkOfShame.background.updateBackground(mode);
        WalkOfShame.logo.onModeChange(mode, calledFromInit);
        WalkOfShame.reelBackground.onModeChange(mode);
        WalkOfShame.possibleWays.onModeChange(mode);
        WalkOfShame.multiplier.onModeChange(mode);
    }

    public static getWinAnimationForSymbol(reelId: number, symId: number, fromInitial: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            sym: WalkOfShameSymbol = WalkOfShame.reels[reelId].getSymbol(symId);

        if (WalkOfShame.mToWild.ifFullSymExistsOnReel(reelId)) {
            if (symId === 1) {
                tl.add(WalkOfShame.mToWild.playWin(reelId, (fromInitial ? "fullInitialWin" : "fullWin")));
            }

            return tl;
        }

        if (!sym.visible || !sym.parent || sym.symbolName.indexOf("S") > -1) {
            return tl;
        }

        tl.add([
            () => {
                // #136 and #172
                if (sym && sym.visible && sym.parent) {
                    WalkOfShame.reels[reelId].reelView.addWinSymbol(sym);
                }
            },
            sym.getStateAnimation(WalkOfShameSymbolState.WIN)
        ]);

        return tl;
    }

    private static createViewsAndComponents(): void {
        //Non views
        new WalkOfShameSound();
        new WalkOfShameLayers();

        //Views
        WalkOfShame.background = new WalkOfShameBackground();
        WalkOfShame.initialCountUp = new InitialWinCountUp();
        WalkOfShame.bigWinCountUp = new BigWinCountUp();
        WalkOfShame.freespinIntro = new FreespinIntro();
        WalkOfShame.freespinOutro = new FreespinOutro();
        WalkOfShame.winCapScreen = new WinCapScreen();
        WalkOfShame.multiplier = new WalkOfShameMultiplier();
        WalkOfShame.winWays = new WalkOfShameWinWays();
        WalkOfShame.stickyS2 = new StickyS2Overlay();
        WalkOfShame.mToWild = new MToWildView();
        WalkOfShame.splitAnimation = new WalkOfShameSplitAnimation();
        WalkOfShame.reelBackground = new WalkOfShameReelBackground();
        WalkOfShame.logo = new WalkOfShameLogo();
        WalkOfShame.blackOverlay = new WalkOfShameBlackOverlay();
        WalkOfShame.possibleWays = new WalkOfShamePossibleWays();
        WalkOfShame.particlesManager = new ParticlesManager();
        WalkOfShame.anticipation = new WalkOfShameAnticipation();
        WalkOfShame.symbolCount = new WalkOfShameSymbolCount();
        WalkOfShame.additionalFS = new WalkOfShameAdditionalFS();

        WalkOfShame.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE,(data:any)=>{
            if (data === true){
                WalkOfShame.isActionSpinsActive = true;
                WalkOfShame.individualWin.stop();
            } else {
                WalkOfShame.isActionSpinsActive = false;
            }
        });

        WalkOfShame.reels = [];
        for (let i: number = 0; i < WalkOfShameGameConfig.REELS_NUM; i++) {
            const reel: WalkOfShameReelController = new WalkOfShameReelController(i);
            WalkOfShame.reels.push(reel);
        }
        WalkOfShame.reelStopPresentations = new ReelStopPresentationManager([
            new ReelStopSoundController(),
            new Scatter2LandingController(),
            new ScatterLandingController()
        ]);
        WalkOfShame.winPresentations = new WinPresentationManager([
            new MToWildController(),
            new ReelSplitController(),
            new RowSplitController(),
            new ReSpinEndController(),
            new ScattersNoWinController(),
            new InitialWinController(),
            new BigWinController(),
            new ReSpinStartController(),
            new FreespinWinController(),
            new FreespinEndController(),
            new BreakBankController()
        ]);
        WalkOfShame.individualWin = new IndividualWinController();
    }

    private static getSymbolString(key: string, data: { [numSymbols: number]: number }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>
        `;
    }

    public async init(): Promise<NolimitPlugin> {
        const value = await super.init();
        WalkOfShame.model = new WalkOfShameModel(WalkOfShame.apiPlugin, true);
        WalkOfShame.gameFlowController = new GameFlowController(WalkOfShame.apiPlugin, WalkOfShame.model);
        WalkOfShame.gameFlowController.flowStateLogger.level = LogLevel.DEV;

        const idleNormal: WalkOfShameNormalIdlePresentation = new WalkOfShameNormalIdlePresentation(),
            reelStart: WalkOfShameNormalBetPresentation = new WalkOfShameNormalBetPresentation(),
            normalResult: WalkOfShameNormalResultPresentation = new WalkOfShameNormalResultPresentation(),
            freeSpinIdle: WalkOfShameFreespinIdlePresentation = new WalkOfShameFreespinIdlePresentation(),
            zeroBetIdle: WalkOfShameZeroBetIdlePresentation = new WalkOfShameZeroBetIdlePresentation(),
            winPres: WalkOfShameWinPresentation = new WalkOfShameWinPresentation();

        WalkOfShame.gameFlowController.addGameModeFlowStatePresentationMap(WalkOfShameGameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, idleNormal],
            [FlowState.BET, reelStart],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        WalkOfShame.gameFlowController.addGameModeFlowStatePresentationMap(WalkOfShameGameMode.RESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, zeroBetIdle],
            [FlowState.BET, reelStart],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        WalkOfShame.gameFlowController.addGameModeFlowStatePresentationMap(WalkOfShameGameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, freeSpinIdle],
            [FlowState.BET, reelStart],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        WalkOfShame.gameFlowController.addGameModeFlowStatePresentationMap(WalkOfShameGameMode.SUPER_FREESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, freeSpinIdle],
            [FlowState.BET, reelStart],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        WalkOfShame.gameFlowController.addGameModeFlowStatePresentationMap(WalkOfShameGameMode.SUPER_FREESPIN_RESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, zeroBetIdle],
            [FlowState.BET, reelStart],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));

        return value;
    }

    public async getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        const value = await super.getReady();

        const fontLoader = new FontLoader(NolimitApplication.resourcePath);
        fontLoader.add(OpenSans.ITALIC_600);
        fontLoader.add(OpenSans.NORMAL_300);
        fontLoader.add(OpenSans.NORMAL_400);
        fontLoader.add(OpenSans.NORMAL_700);

        AssetsConfig.addToAssetsConfig(WalkOfShameGameAssets.RESOURCES_GROUPS);
        WalkOfShame.assetLoader = new AssetLoader(WalkOfShame.apiPlugin, NolimitApplication.resourcePath + "/resources/");

        await Promise.all([fontLoader.load(), WalkOfShame.assetLoader.load(ResourcesGroupName.MAIN)]);
        await WalkOfShame.createViewsAndComponents();
        return value;
    }

    public async getReadyToStart(): Promise<NolimitPlugin> {
        // restored in any of FS modes
        if (WalkOfShame.model.isRestore && WalkOfShame.model.parsedInitData.mode.indexOf(WalkOfShameGameMode.FREESPIN) > -1) {
            WalkOfShame.multiplier.updateMultiplierText(WalkOfShame.model.parsedInitData.currentMultiplier, false);
            WalkOfShame.multiplier.toggleMultiplier(true);
        }

        WalkOfShame.mToWild.onInit(WalkOfShame.model.parsedInitData.mToWildFeature);

        return await super.getReadyToStart();
    }

    public async start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.

        const value = await super.start(),
            parsedInitData: WalkOfShameParsedInitData = WalkOfShame.model.parsedInitData,
            mode: string = parsedInitData.mode;

        // #174 -> moved it here, in order to avoid the race condition between getReady method of slot-game/game and slot-keypad.
        if (WalkOfShame.model.isRestore && parsedInitData.showTotalWin) {
            WalkOfShame.keypadPlugin.setWin(parsedInitData.totalWin, true, BelowStakeWinRestriction.isWinBelowStake());
        }

        if (mode === WalkOfShameGameMode.NORMAL || mode === WalkOfShameGameMode.RESPIN) {
            WalkOfShame.updateMode(mode, true);
        }

        WalkOfShame.gameFlowController.start();
        WalkOfShameSound.switchMusic({name: WalkOfShameSound.getMusicNameByMode(WalkOfShame.model.data.nextMode)});

        return value;
    }

    public getPaytable(): Promise<string> {
        const templateLoader: TemplateLoader = new TemplateLoader(WalkOfShame.apiPlugin.resources.getStaticRoot());

        templateLoader.add({
            name: "Paytable",
            url: "nolimit/screens/paytable.mustache"
        });

        let symbolDataValueData: ISymbolValues = this._defaultSymbolValues;
        if (WalkOfShame.model.parsedInitData.symbolValues) {
            symbolDataValueData = WalkOfShame.model.parsedInitData.symbolValues;
            Logger.logDev("Using symbolValues from INIT data");
        } else {
            Logger.logDev("Using default symbolValues");
        }

        return templateLoader.load().then((assets: TemplateAsset[]) => {
            for (let asset of assets) {
                if (asset.name === "Paytable" && asset.loadedData) {
                    for (let key in symbolDataValueData) {
                        asset.loadedData = asset.loadedData.replace(`{{${key}}}`, WalkOfShame.getSymbolString(key, symbolDataValueData[key]));
                    }
                    return asset.loadedData;
                }
            }
            throw new Error("FolsomPrison could not load Paytable");
        });
    }

    public getNoWinGameData(): any {
        return {
            "reels": [
                [
                    "M3",
                    "L1",
                    "L3",
                    "L2",
                    "L1",
                    "M4"
                ],
                [
                    "L1",
                    "M4",
                    "L3",
                    "L5",
                    "M4",
                    "M2"
                ],
                [
                    "L5",
                    "M2",
                    "L4",
                    "L2",
                    "M3",
                    "L4"
                ],
                [
                    "M4",
                    "L4",
                    "S",
                    "M2",
                    "M4",
                    "L1"
                ],
                [
                    "M4",
                    "L4",
                    "S",
                    "L3",
                    "M1",
                    "L4"
                ]
            ],
            "evaluatedArea": [
                [
                    "L1",
                    "L3",
                    "L2",
                    "X"
                ],
                [
                    "M4",
                    "L3",
                    "L5",
                    "M4"
                ],
                [
                    "M2",
                    "L4",
                    "L2",
                    "M3"
                ],
                [
                    "L4",
                    "S",
                    "M2",
                    "M4"
                ],
                [
                    "L4",
                    "S",
                    "L3",
                    "M1"
                ]
            ],
            "betWayWins": [],
            "totalBetWayWinnings": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "freespinTriggeredThisSpin": false,
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "wasFeatureBuy": false,
            "totalNumberWaysWon": 0,
            "brokeBank": false,
            "enhancedBet": false
        };
    }
}